/* Смена содержимого #studio. Раздел и экраны создания собирают разметку строкой, как прототип,
   и дорисовывают её сразу после вставки (класс fit лотка, кадры фрагмента, длительность).
   Эту строку нельзя класть в состояние React из эффекта компоновки: повторный кадр доезжает
   уже после дорисовок и стирает их. Узел #studio — React, содержимое ведёт экран.
   Привязки — стопка: разметку получает хозяин верхней (по умолчанию #studio; кадр движка студии, engine-kit/EngineFrame, —
   свой .st-eng). Снятие по жетону убирает только свою привязку; bindStudioPaint(false) снимает все (прежние вызовы). */
interface PaintBinding {
  /** Куда ставить разметку; без него — #studio на момент постановки */
  host?: HTMLElement;
}
const bindings: PaintBinding[] = [];

/** on=true — новая привязка сверху стопки (host по умолчанию — #studio), возвращает её снятие: оно убирает только эту привязку.
    on=false — снять все привязки (экран «Студия» ушёл); ничего не возвращает, поэтому годится очисткой эффекта как есть */
export function bindStudioPaint(on: true, host?: HTMLElement): () => void;
export function bindStudioPaint(on: false): void;
export function bindStudioPaint(on: boolean, host?: HTMLElement): (() => void) | void;
export function bindStudioPaint(on: boolean, host?: HTMLElement): (() => void) | void {
  if (!on) {
    bindings.length = 0;
    return;
  }
  const binding: PaintBinding = host ? { host } : {};
  bindings.push(binding);
  return () => {
    const at = bindings.indexOf(binding);
    if (at >= 0) bindings.splice(at, 1);
  };
}

/** Поставить разметку в хозяина верхней привязки. Класс элемента сохраняется: его выставляет раздел до этой постановки. */
export function paintStudio(html: string) {
  const top = bindings.at(-1);
  if (!top) return;
  const el = top.host ?? document.getElementById('studio');
  if (!el) return;
  const cls = el.className;
  el.innerHTML = html;
  if (cls) el.className = cls;
}
